export var NumericEditorType;
(function (NumericEditorType) {
    NumericEditorType[NumericEditorType["Byte"] = 0] = "Byte";
    NumericEditorType[NumericEditorType["SByte"] = 1] = "SByte";
    NumericEditorType[NumericEditorType["Int16"] = 2] = "Int16";
    NumericEditorType[NumericEditorType["UInt16"] = 3] = "UInt16";
    NumericEditorType[NumericEditorType["Int32"] = 4] = "Int32";
    NumericEditorType[NumericEditorType["UInt32"] = 5] = "UInt32";
    NumericEditorType[NumericEditorType["Int64"] = 6] = "Int64";
    NumericEditorType[NumericEditorType["UInt64"] = 7] = "UInt64";
    NumericEditorType[NumericEditorType["Double"] = 8] = "Double";
    NumericEditorType[NumericEditorType["Single"] = 9] = "Single";
    NumericEditorType[NumericEditorType["Decimal"] = 10] = "Decimal";
})(NumericEditorType || (NumericEditorType = {}));
;
